<div class="page-container cfp-container container unified-context">
  <app-utility-toolbar />
  <h1 class="header col-12">
    Cash Flow Planner
    @if (calcComplete) {
      <button
        type="button"
        mat-button
        color="primary"
        class="header-button"
        (click)="editCalc()"
      >
        <mat-icon>create</mat-icon>Edit Calculation
      </button>
    }
    @if (calcComplete) {
      <button
        type="button"
        mat-button
        color="primary"
        class="header-button"
        (click)="resetCalc()"
      >
        <mat-icon>clear</mat-icon>Clear Calculation
      </button>
    }
  </h1>
  @if (!calcComplete) {
    <form
      [formGroup]="formData"
      (ngSubmit)="formData.valid && calculate(formData)"
    >
      <div class="row">
        <div class="col-12">
          <h2>Client Information</h2>
        </div>
        <mat-form-field class="col-3 mb-3">
          <mat-label>Current Age</mat-label>
          <input
            matInput
            placeholder="Age"
            name="AgeAtIssue"
            formControlName="AgeAtIssue"
            type="number"
          />
        </mat-form-field>
        <mat-form-field class="col-3 mb-3">
          <mat-label>Retirement Age</mat-label>
          <input
            matInput
            placeholder="Retirement Age"
            name="AgeAtRetirement"
            formControlName="AgeAtRetirement"
            type="number"
          />
        </mat-form-field>
        <mat-form-field class="col-3 mb-3">
          <mat-label>Age at End of Plan</mat-label>
          <input
            matInput
            placeholder="Age at End of Plan"
            name="MortalityAge"
            formControlName="MortalityAge"
            type="number"
          />
        </mat-form-field>
        <mat-form-field class="col-3 mb-3">
          <mat-label>Retirement Withdrawal COLA</mat-label>
          <input
            matInput
            placeholder="Retirement Withdrawal COLA"
            name="RequiredWithdrawalCOLA"
            formControlName="RequiredWithdrawalCOLA"
            [maskito]="percentMask"
          />
        </mat-form-field>
        <div class="col-12 mb-3">
          <div class="col-12 row mb-3">
            <div class="col-6">
              <mat-label>Withdrawal Method:</mat-label>
              <mat-radio-group
                name="WithdrawalMethod"
                formControlName="WithdrawalMethod"
              >
                <mat-radio-button [value]="'Dollar Amount'"
                  >Dollar Amount</mat-radio-button
                >
                <mat-radio-button [value]="'Percentage'"
                  >Percentage Amount</mat-radio-button
                >
              </mat-radio-group>
            </div>
            <div class="col-6">
              <mat-label>Guaranteed Income before Retirement:</mat-label>
              <mat-radio-group
                name="IncomePreRetirement"
                formControlName="IncomePreRetirement"
              >
                <mat-radio-button [value]="'spend'">Spend</mat-radio-button>
                <mat-radio-button [value]="'reinvest'"
                  >Add to Portfolio</mat-radio-button
                >
              </mat-radio-group>
            </div>
          </div>

          @if (formData.controls.WithdrawalMethod.value === 'Dollar Amount') {
            <mat-form-field class="col-3">
              <mat-label>Annual Retirement Income Needed</mat-label>
              <input
                matInput
                placeholder="Annual Retirement Income Needed"
                name="AnnualIncomeNeed"
                formControlName="AnnualIncomeNeed"
                [maskito]="dollarMask"
              />
            </mat-form-field>
          } @else if (
            formData.controls.WithdrawalMethod.value === 'Percentage'
          ) {
            <mat-form-field class="col-3">
              <mat-label>Annual Withdrawal (%)</mat-label>
              <input
                matInput
                placeholder="Annual Withdrawal (%)"
                name="AnnualWithdrawalPercent"
                formControlName="AnnualWithdrawalPercent"
                [maskito]="percentMask"
              />
            </mat-form-field>
          }
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <h2>Guaranteed Income Sources</h2>
        </div>
        <div class="col-6 mb-2">
          <h5>Annuity 1</h5>
          <div class="row">
            <mat-form-field class="col-12">
              <mat-label>Age to Start Income</mat-label>
              <input
                matInput
                placeholder="Age to Start Income"
                name="AgeAtFirstWithdrawal"
                formControlName="AgeAtFirstWithdrawal"
                type="number"
              />
            </mat-form-field>
          </div>
          <div class="row">
            <mat-form-field class="col-12">
              <mat-label>Guaranteed Annual Income</mat-label>
              <input
                matInput
                placeholder="Guaranteed Annual Income"
                name="LifetimeIncome"
                formControlName="LifetimeIncome"
                [maskito]="dollarMask"
              />
            </mat-form-field>
          </div>
          <div class="row">
            <mat-form-field class="col-12">
              <mat-label>Rising Income Rate</mat-label>
              <input
                matInput
                placeholder="Rising Income Rate"
                name="IncomeRisingRate"
                formControlName="IncomeRisingRate"
                [maskito]="percentMask"
              />
            </mat-form-field>
          </div>
        </div>
        <div class="col-6 mb-2">
          <h5>Annuity 2</h5>
          <div class="row">
            <mat-form-field class="col-12">
              <mat-label>Age to Start Income</mat-label>
              <input
                matInput
                placeholder="Age to Start Income"
                name="AgeAtFirstWithdrawal2"
                formControlName="AgeAtFirstWithdrawal2"
                type="number"
              />
            </mat-form-field>
          </div>
          <div class="row">
            <mat-form-field class="col-12">
              <mat-label>Guaranteed Annual Income</mat-label>
              <input
                matInput
                placeholder="Guaranteed Annual Income"
                name="LifetimeIncome2"
                formControlName="LifetimeIncome2"
                [maskito]="dollarMask"
              />
            </mat-form-field>
          </div>
          <div class="row">
            <mat-form-field class="col-12">
              <mat-label>Rising Income Rate</mat-label>
              <input
                matInput
                placeholder="Rising Income Rate"
                name="IncomeRisingRate2"
                formControlName="IncomeRisingRate2"
                [maskito]="percentMask"
              />
            </mat-form-field>
          </div>
        </div>
        <div class="col-6 mb-2">
          <h5>Social Security</h5>
          <div class="row">
            <mat-form-field class="col-12">
              <mat-label>Age to Start Income</mat-label>
              <input
                matInput
                placeholder="Age to Start Income"
                name="ClientSocialSecurityAge"
                formControlName="ClientSocialSecurityAge"
                type="number"
              />
            </mat-form-field>
          </div>
          <div class="row">
            <mat-form-field class="col-12">
              <mat-label>Guaranteed Annual Income</mat-label>
              <input
                matInput
                placeholder="Guaranteed Annual Income"
                name="ClientSocialSecurityAmount"
                formControlName="ClientSocialSecurityAmount"
                [maskito]="dollarMask"
              />
            </mat-form-field>
          </div>
          <div class="row">
            <mat-form-field class="col-12">
              <mat-label>Rising Income Rate</mat-label>
              <input
                matInput
                placeholder="Rising Income Rate"
                name="ClientSocialSecurityCOLA"
                formControlName="ClientSocialSecurityCOLA"
                [maskito]="percentMask"
              />
            </mat-form-field>
          </div>
        </div>
        <div class="col-6 mb-2">
          <h5>Spouse Social Security</h5>
          <div class="row">
            <mat-form-field class="col-12">
              <mat-label>Age to Start Income</mat-label>
              <input
                matInput
                placeholder="Age to Start Income"
                name="SpouseSocialSecurityAge"
                formControlName="SpouseSocialSecurityAge"
                type="number"
              />
            </mat-form-field>
          </div>
          <div class="row">
            <mat-form-field class="col-12">
              <mat-label>Guaranteed Annual Income</mat-label>
              <input
                matInput
                placeholder="Guaranteed Annual Income"
                name="SpouseSocialSecurityAmount"
                formControlName="SpouseSocialSecurityAmount"
                [maskito]="dollarMask"
              />
            </mat-form-field>
          </div>
          <div class="row">
            <mat-form-field class="col-12">
              <mat-label>Rising Income Rate</mat-label>
              <input
                matInput
                placeholder="Rising Income Rate"
                name="SpouseSocialSecurityCOLA"
                formControlName="SpouseSocialSecurityCOLA"
                [maskito]="percentMask"
              />
            </mat-form-field>
          </div>
        </div>
        <div class="col-6 mb-2">
          <h5>Pension</h5>
          <div class="row">
            <mat-form-field class="col-12">
              <mat-label>Age to Start Income</mat-label>
              <input
                matInput
                placeholder="Age to Start Income"
                name="ClientPensionStartAge"
                formControlName="ClientPensionStartAge"
                type="number"
              />
            </mat-form-field>
          </div>
          <div class="row">
            <mat-form-field class="col-12">
              <mat-label>Guaranteed Annual Income</mat-label>
              <input
                matInput
                placeholder="Guaranteed Annual Income"
                name="ClientPensionIncome"
                formControlName="ClientPensionIncome"
                [maskito]="dollarMask"
              />
            </mat-form-field>
          </div>
        </div>
        <div class="col-6 mb-2">
          <h5>Spouse Pension</h5>
          <div class="row">
            <mat-form-field class="col-12">
              <mat-label>Age to Start Income</mat-label>
              <input
                matInput
                placeholder="Age to Start Income"
                name="SpousePensionStartAge"
                formControlName="SpousePensionStartAge"
                type="number"
              />
            </mat-form-field>
          </div>
          <div class="row">
            <mat-form-field class="col-12">
              <mat-label>Guaranteed Annual Income</mat-label>
              <input
                matInput
                placeholder="Guaranteed Annual Income"
                name="SpousePensionIncome"
                formControlName="SpousePensionIncome"
                [maskito]="dollarMask"
              />
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <h2>Investment Portfolio</h2>
        </div>
        <mat-form-field class="col-3 mb-3">
          <mat-label>Equity Holdings</mat-label>
          <input
            matInput
            placeholder="Equity Holdings"
            name="EquityHoldings"
            formControlName="EquityHoldings"
            [maskito]="dollarMask"
          />
        </mat-form-field>
        <mat-form-field class="col-3 mb-3">
          <mat-label>Fixed Income</mat-label>
          <input
            matInput
            placeholder="Fixed Income"
            name="FixedIncome"
            formControlName="FixedIncome"
            [maskito]="dollarMask"
          />
        </mat-form-field>
        <mat-form-field class="col-3 mb-3">
          <mat-label>Investment Annuity</mat-label>
          <input
            matInput
            placeholder="Investment Annuity"
            name="Annuity"
            formControlName="Annuity"
            [maskito]="dollarMask"
          />
        </mat-form-field>
        <mat-form-field class="col-3 mb-3">
          <mat-label>Income Annuity</mat-label>
          <input
            matInput
            placeholder="Income Annuity"
            name="IncomeAnnuity"
            formControlName="IncomeAnnuity"
            [maskito]="dollarMask"
          />
        </mat-form-field>
        <mat-form-field class="col-3 mb-3">
          <mat-label>Equity Holdings Rate</mat-label>
          <input
            matInput
            placeholder="Equity Holdings Rate"
            name="EquityHoldingsRate"
            formControlName="EquityHoldingsRate"
            [maskito]="percentMask"
          />
        </mat-form-field>
        <mat-form-field class="col-3 mb-3">
          <mat-label>Fixed Income Rate</mat-label>
          <input
            matInput
            placeholder="Fixed Income Rate"
            name="FixedIncomeRate"
            formControlName="FixedIncomeRate"
            [maskito]="percentMask"
          />
        </mat-form-field>
        <mat-form-field class="col-3 mb-3">
          <mat-label>Annuity Rate</mat-label>
          <input
            matInput
            placeholder="Annuity Rate"
            name="AnnuityRate"
            formControlName="AnnuityRate"
            [maskito]="percentMask"
          />
        </mat-form-field>
        <mat-form-field class="col-3 mb-3">
          <mat-label>Income Annuity Rate</mat-label>
          <input
            matInput
            placeholder="Income Annuity Rate"
            name="IncomeAnnuityRate"
            formControlName="IncomeAnnuityRate"
            [maskito]="percentMask"
          />
        </mat-form-field>
      </div>
      <div class="row">
        <div class="col-6">
          <button mat-raised-button color="accent" type="submit">
            <mat-icon>polls</mat-icon>Calculate
          </button>
        </div>
      </div>
    </form>
  }

  @if (calcComplete) {
    <div>
      <div class="row my-3">
        @for (chart of chartData; track chart) {
          <div class="chart-container col-6 mx-auto results-table">
            <highcharts-chart
              class="w-100 mx-auto"
              [Highcharts]="Highcharts"
              [options]="chart"
            />
          </div>
        }
      </div>
      <app-grid-column-filter
        class="ms-auto me-2 pull-right"
        [omitCols]="[]"
        [columns]="tableColumns"
        (columnsUpdated)="externalColumnsUpdated($event)"
      />
      <kendo-grid
        #resultsGrid="kendoGrid"
        class="col-12 search-grid"
        height="500"
        [scrollable]="true"
        [kendoGridBinding]="tableData"
        [pageable]="false"
        [sortable]="{ allowUnsort: true, mode: 'multiple' }"
        [resizable]="true"
      >
        @for (col of tableColumns; let i = $index; track i) {
          <kendo-grid-column
            field="{{ col.DataField }}"
            title="{{ col.Label }}"
            [hidden]="isHidden(col.DataField)"
          >
            <ng-template let-dataItem kendoGridCellTemplate>
              @if (col.ControlType === 'curr') {
                {{ dataItem[col.DataField] | currency }}
              } @else if (col.ControlType === 'perc') {
                {{ dataItem[col.DataField] | percent: '1.2-2' }}
              } @else {
                {{ dataItem[col.DataField] }}
              }
            </ng-template>
          </kendo-grid-column>
        }
      </kendo-grid>
    </div>
  }
  <ngx-loading [show]="loading" />
</div>
